import { Paper, Stack } from '@mui/material';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import FilterSection from '../TopCardOverview/FilterSection';
import React, { useEffect, useState } from 'react';
import { typeOfStudent } from '../../../../utils/constants/GlobalStaticData';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { getRefundRoleWiseTable } from '../../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';

export default function RoleWiseRequest() {
  const tableHead = [
    {
      field: 'role',
      headerName: 'Role',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'total_refund_request_count',
      headerName: 'Total Refund Req Count',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'expense_amount',
      headerName: 'Total Refund Req Amount',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
  ];

  const [showFilters, setShowFilters] = useState(true);
  const [selectedType, setSelectedType] = useState(typeOfStudent[0]);
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [selectedRole, setSelectedRole] = useState({ id: null, value: null });

  const { data, refundRoleWiseLoading, meta } = useSelector((state) => state.refund?.refundRoleWiseTable);
  const {
    paginationData: { gridSize, pageNum, search },
  } = useSelector((state) => state.globalDataGrid);

  const dispatch = useDispatch();
  const dispatchParams = React.useMemo(() => {
    return {
      type: selectedType?.id,
      fromDate: fromDate,
      toDate: toDate,
      role: selectedRole?.id,
      page: pageNum,
      limit: gridSize,
      search: search,
    };
  }, [selectedType, fromDate, toDate, search, gridSize, pageNum, selectedRole]);

  useEffect(() => {
    dispatch(getRefundRoleWiseTable(dispatchParams));
  }, [search, gridSize, pageNum]);

  const filterSubmit = React.useCallback(() => {
    dispatch(getRefundRoleWiseTable(dispatchParams));
  }, [dispatch, dispatchParams]);

  return (
    <Stack gap={1}>
      <FilterSection
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        selectedRole={selectedRole}
        setSelectedRole={setSelectedRole}
        filterSubmit={filterSubmit}
        loading={false}
      />
      <Paper elevation={3}>
        <GlobalDatagrid
          tableHead={tableHead}
          rowUniqueId={'userId'}
          rows={data}
          meta={meta?.totalRecords}
          loading={refundRoleWiseLoading}
        />
      </Paper>
    </Stack>
  );
}
